module.exports = __webpack_public_path__ + "media/2x/3-1ff425a8.png";